import script from "./VLimitTag.vue?vue&type=script&lang=ts&setup=true"
export * from "./VLimitTag.vue?vue&type=script&lang=ts&setup=true"

import "./VLimitTag.vue?vue&type=style&index=0&id=7bdb2859&lang=sass"

const __exports__ = script;

export default __exports__